/* Step 12-1 · lane S12A (every note ties, A0–A5) — EN + AR of
   - the notes tab: the red difference line of a note that does not tie (components/notes/NoteTies.jsx · NoteFooter) and the
     movement table read from the ledger (NoteLedgerMovements); the figures and line names come from the server (note_ties.py,
     fs_note_movements_ledger.py);
   - the Clearance gate (W11) item 10 "All notes tie to the statements" (w11._notes_tie).
   The cash-flow net labels by sign come from the server (cf_net_label.py, EN + AR). No standard paragraph is quoted. */
const I18N_S12A = {
  en: {
    s12a: {
      notes: {
        doesNotTie: "Does not tie",
        currentYear: "current year",
        priorYear: "prior year",
        noteFigure: "note",
        statementFigure: "statement",
        difference: "difference",
      },
      movements: {
        title: "Movements for the year",
        line: "Line",
        opening: "Opening",
        closing: "Closing",
      },
    },
    w11: {
      subtitle: "The checks that must be green before the Partner may sign off.",
      items: { checklist_10: "All notes tie to the statements" },
      details: {
        notes_untied: "{count} note(s) do not tie to the statements: note(s) {notes}. Open IFRS Statements → Validation for the differences.",
        notes_tie_ok: "All {count} notes with figures tie to the statements",
        notes_tie_none: "No financial statements yet (set the presentation framework and load the data)",
        notes_tie_final: "Not applied: a report version is already Final",
        notes_tie_unavailable: "The note ties could not be read — open IFRS Statements → Validation",
      },
    },
  },
  ar: {
    s12a: {
      notes: {
        doesNotTie: "لا يطابق",
        currentYear: "السنة الحالية",
        priorYear: "السنة السابقة",
        noteFigure: "الإيضاح",
        statementFigure: "القائمة",
        difference: "الفرق",
      },
      movements: {
        title: "الحركات خلال السنة",
        line: "البند",
        opening: "الرصيد الافتتاحي",
        closing: "الرصيد الختامي",
      },
    },
    w11: {
      subtitle: "المتطلبات التي يجب أن تكون خضراء قبل توقيع الشريك.",
      items: { checklist_10: "جميع الإيضاحات تطابق القوائم المالية" },
      details: {
        notes_untied: "{count} إيضاح/إيضاحات لا تطابق القوائم المالية: الإيضاح/الإيضاحات {notes}. افتح القوائم المالية ← التحقق لعرض الفروق.",
        notes_tie_ok: "جميع الإيضاحات ذات الأرقام ({count}) تطابق القوائم المالية",
        notes_tie_none: "لا توجد قوائم مالية بعد (حدّد إطار العرض وحمّل البيانات)",
        notes_tie_final: "لا ينطبق: توجد نسخة تقرير نهائية",
        notes_tie_unavailable: "تعذّرت قراءة مطابقة الإيضاحات — افتح القوائم المالية ← التحقق",
      },
    },
  },
};

export default I18N_S12A;
